export const GET_BILLING_STATUS = "GET_BILLING_STATUS";
export const LOADER_FOR_BILLING_STATUS = "LOADER_FOR_BILLING_STATUS";
export const RESET_FOR_BILLING_STATUS = "RESET_FOR_BILLING_STATUS";

export interface IBillingStatusState {
    isBillingStatusLoaded: boolean;
    billingStatus : boolean
}


export interface loaderForBillingStatus {
    type: "LOADER_FOR_BILLING_STATUS";
    isBillingStatusLoaded: boolean;
}
export interface getBillingStatus {
    type: "GET_BILLING_STATUS";
    billingStatus: boolean;
}
export interface resetBillingStatus {
    type: "RESET_FOR_BILLING_STATUS";
}
export type KnownAction = getBillingStatus | loaderForBillingStatus | resetBillingStatus;
